import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from '../../user/services/user.service';
import { UserRole } from '../../../enums/user-role.enum';
import { routeNames } from '../../../shared/route-names';

export const createRoleGuard = (allowedRoles: UserRole[], redirectTo: string = routeNames.home) => {
  return () => {
    const router = inject(Router);
    const userService = inject(UserService);
    
    const isLoggedIn = userService.isLoggedIn();
    const user = userService.getUser().value;
    const hasRequiredRole = user?.role && allowedRoles.includes(user.role);
    
    return isLoggedIn && hasRequiredRole ? true : router.navigateByUrl(redirectTo);
  };
};

export const AdminGuard = createRoleGuard([UserRole.SUPER_ADMIN]);

export const AdministrationGuard = createRoleGuard([UserRole.SUPER_ADMIN, UserRole.CHIEF_INSPECTOR]);